import { isString } from '../string/isString';
/**
 * Проверяет является ли переданное значение массивом строк.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является массивом строк, иначе false.
 * @example
 * ```typescript
 * import { isArrayOfStrings } from '@direct-frontend/stdlib';
 *
 * isArrayOfStrings(['1', '2', '3']); // true
 * isArrayOfStrings(null); // false
 * isArrayOfStrings('string'); // false
 * ```
 */
export function isArrayOfStrings(value) {
    return Array.isArray(value) && value.every(isString);
}
